import isocountries from "../../country";
import { type } from "../charge/utils";
import { isPlainObject } from "../utils";


const isoCountryOptions = Object.freeze(isocountries);

function selectIsoCountryFromList(list, isoCountryOption) {
    if (type(list) !== 'array') return null;

    if (list.indexOf(isoCountryOption) < 0) {
        const isoCountryObject = isPlainObject(isoCountryOption);

        const { name: isoCountryName, sortname: isoCountryIdentifier } =
        isoCountryObject
            ? isoCountryOption
            : (isoCountryOption = String(isoCountryOption), { name: isoCountryOption, identifier: isoCountryOption });

        isoCountryOption = list.find(item => {
            if (isPlainObject(item)) {
                const { name, sortname } = item;

                const hasName = typeof isoCountryName !== 'undefined';
                const hasIdentifier = typeof isoCountryIdentifier !== 'undefined';

                let matches = (hasName || hasIdentifier) ? 1 : 0;

                if (isoCountryObject) {
                    hasName && (matches = matches & (isoCountryName === name));
                    hasIdentifier && (matches = matches & (isoCountryIdentifier === sortname));
                } else {
                    matches = matches & (
                        hasName && isoCountryName === name || 
                        hasIdentifier && isoCountryIdentifier === sortname
                    );
                }

                return matches;
            }
        });
    }
    return isoCountryOption || null;
}

export {
    isoCountryOptions,
    selectIsoCountryFromList
}